import React from "react";

/**
 * DS Toggle — figma 287:419 (property1=true). 40×22 pill switch.
 *
 * on: BG/Accent (#006AFF), thumb white 14×14 right
 * off: Bg/Paper-dark, thumb white left
 *
 * @param {object} props
 * @param {boolean} props.checked
 * @param {(checked: boolean) => void} props.onChange
 * @param {boolean} [props.disabled]
 * @param {"default"|"red"} [props.variant] - red = 옵션별 품절 toggle 등 destructive 용 (System/Error bg)
 */
const DSToggle = ({
  checked,
  onChange,
  disabled,
  className = "",
  variant = "default",
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      disabled={disabled}
      className={[
        "ds-toggle",
        checked && "ds-toggle--on",
        variant === "red" && "ds-toggle--red",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={() => onChange && onChange(!checked)}
    >
      <span className="ds-toggle__thumb" />
    </button>
  );
};

export default React.memo(DSToggle);
